import { salesChannelIsIfood } from "../../utils/check-sales-channel";

export const devolutionMatchers = [
  { 
    key: "iFood",
    match: ({ erpOrigem }) => salesChannelIsIfood(erpOrigem) },
  {
    key: "sfsEstadual",
    match: ({ origem, tipoEntrega }) =>
      origem === "SHIP_FROM_STORE" && tipoEntrega === "SAME_STATE",
  },
];
